export default __webpack_public_path__ + "static/media/bg2.2a50727d.png";